import Script from "next/script";
import React from "react";

interface IProps {
  pid: string;
}

const AdSense = ({ pid }: IProps) => {
  if (!pid) return null;

  return (
    <>
      {/* Loads the gtag script */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${pid}`}
        strategy="afterInteractive"
        async
      />

      {/* Initializes gtag with config */}
      <Script id="gtag-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${pid}');
        `}
      </Script>
    </>
  );
};

export default AdSense;
